import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function AdsSlide() {
  const navigate = useNavigate();
    
  return (
    <Box sx={{ background: 'linear-gradient(135deg, #A3B18A 30%,  #2ab7ca 80%)', py: { xs: 2, sm: 4, md: 8 }, px: { xs: 2, md: 5 }, mb: 2, display: 'flex', flexDirection: { xs: 'column', md: 'row' }, flex: 1, columnGap: 2, alignItems: 'center', justifyContent: 'center' }}>
      <Typography variant="h1" sx={{ whiteSpace: 'break-spaces', textTransform: 'uppercase', color: 'primary.main', fontFamily: 'Allan', fontSize: { xs: 30, sm: 48, md: 60 }, textAlign: 'left', textShadow: `6px 4px 0 rgba(255,255,255,0.5), 5px 3px 0 rgba(255,255,255,0.5), 4px 2px 0 rgba(255,255,255,0.5), 3px 1px 0 rgba(255,255,255,0.5), 2px 0px 0 rgba(255,255,255,0.5)`, minWidth: { md: '400px' } }}>
        Vous organisez<br />
        <Box component="span" sx={{ ml: { md: '150px', xs: 15 }, display: 'inline-block', mt: { md: '40px' } }}>un événement ?</Box>
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', flex: 1, rowGap: {xs: 2, md: 4}, textAlign: 'center' }}>
        <Typography variant="body1" sx={{ mt: 2, fontSize: { xs: 12, sm: 18, md: 20 }, textTransform: 'uppercase' }}>
          Ne cherchez plus, notre billetterie est faite pour vous.<br />
          Faites votre demande dès maintenant !
        </Typography>
        <Button variant="contained" onClick={() => navigate("/contact")} 
        sx={{ textTransform: 'uppercase', borderRadius: 50, border: '2px solid white', backgroundColor: 'transparent', color: 'white', px: {xs: 2, sm: 4}, py: {sm: 1.5}, fontSize: { xs: 12, sm: 16 } }}>
          Je fais ma demande
        </Button>
      </Box>
    </Box>
  )
}